module.exports = __webpack_public_path__ + "img/Angola.9b4be8f2.svg";